<template>
  <el-form
    ref="form"
    v-loading="isLoading"
    :model="budget"
    label-width="auto"
    :rules="rules"
  >
    <el-row>
      <el-col>
        <el-form-item
          label="Budget Name"
          prop="name"
        >
          <el-input
            v-model="budget.name"
            placeholder="Budget Name"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Target"
          prop="target"
        >
          <el-input-number
            v-model="budget.target"
            :precision="2"
            :step="100000"
            :min="0"
            placeholder="Target of Budget"
            class="w-100"
            controls-position="right"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Date Range"
          prop="dateRange"
        >
          <el-date-picker
            v-model="budget.dateRange"
            type="monthrange"
            range-separator="To"
            start-placeholder="Start Month"
            end-placeholder="End Month"
            class="w-100"
          />
          <!-- <el-select
            v-model="budget.dateRange"
            placeholder="Date Range"
            class="w-100"
            clearable
          >
            <el-option
              v-for="(dateRange, index) in dateRanges"
              :key="index"
              :label="dateRange"
              :value="dateRange"
            />
          </el-select> -->
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Portfolio Type"
          prop="portfolioType"
        >
          <el-select
            v-model="budget.portfolioType"
            placeholder="Portfolio Type"
            value-key="id"
            class="w-100"
            clearable
          >
            <el-option
              v-for="portfolioType in portfolioTypes"
              :key="portfolioType.id"
              :label="portfolioType.name"
              :value="portfolioType"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    budget: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      dateRanges: ['Year 2019', 'Q1 2019', 'Q2 2019', 'Q3 2019', 'Q4 2019', 'Year 2020'],
      portfolioTypes: [],
      isLoading: false,
      rules: {
        name: [
          { required: true, message: 'Budget Name is required', trigger: 'blur' }
        ],
        target: [
          { required: true, message: 'Budget Target is required', trigger: 'blur' }
        ],
        dateRange: [
          { required: true, message: 'Budget Date Range is required', trigger: 'change' }
        ]
        // portfolioType: [
        //   { required: true, message: 'Budget Portfolio Type is required', trigger: 'change' }
        // ]
      }
    }
  },
  methods: {
    validate () {
      return new Promise(resolve => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve(true)
          }
        })
      })
    }
  }
}
</script>

<style>

</style>
